// src/components/StatusTag.tsx
import React from "react";
import { Chip } from "@mui/material";
import { STATUS_STYLES } from "../../Constants/Colors";

interface StatusTagProps {
  status: string;
}

const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const statusKey = status?.toLowerCase() || "default";
  const { textColor, tagColor } = STATUS_STYLES[statusKey] || STATUS_STYLES.default;
  const sanitizedStatus = statusKey.replace('_', ' ');
  const sanitizedStatusKey = "Consultation " +  sanitizedStatus?.charAt(0)?.toUpperCase() + sanitizedStatus?.slice(1);
  return (
    <Chip
      label={sanitizedStatusKey}
      style={{
        backgroundColor: tagColor,
        color: textColor,
        fontWeight: 500,
      }}
    />
  );
};

export default StatusTag;
